import { render, staticRenderFns } from "./optimisation-du-quality-score-sur-google-ads-comment-ameliorer-votre-classement-dannonce.vue?vue&type=template&id=b8e85704&"
import script from "./optimisation-du-quality-score-sur-google-ads-comment-ameliorer-votre-classement-dannonce.vue?vue&type=script&lang=js&"
export * from "./optimisation-du-quality-score-sur-google-ads-comment-ameliorer-votre-classement-dannonce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports